<script lang="ts">
  let { privacy = 'full_disclosure', currentUser = {} as Record<string, any> }: { privacy?: string; currentUser?: Record<string, any> } = $props()

  const privacyLevels = {
    full_disclosure: {
      icon: '🌐',
      label: '전체 공개',
      description: '모두에게 공개됩니다',
      color: 'blue',
      visibility: ['글 내용 공개', '작성자 이름 공개', '댓글 가능', '검색 가능']
    },
    company_only: {
      icon: '🏢',
      label: '회사 공개',
      description: '같은 회사 회원만 볼 수 있습니다',
      color: 'green',
      visibility: ['글 내용 공개', '회사명 표시', '댓글 가능', '검색 불가']
    },
    name_only: {
      icon: '👤',
      label: '이름만',
      description: '연결된 사용자만 볼 수 있습니다',
      color: 'purple',
      visibility: ['글 내용 공개', '실명 표시', '댓글 가능', '검색 불가']
    },
    anonymous: {
      icon: '🔒',
      label: '익명',
      description: '오직 당신만 볼 수 있습니다',
      color: 'gray',
      visibility: ['글 내용 비공개', '닉네임만 표시', '댓글 불가', '검색 불가']
    }
  }

  const current = $derived(privacyLevels[privacy as keyof typeof privacyLevels] || privacyLevels.full_disclosure)

  const colorClasses = {
    blue: 'bg-blue-50 dark:bg-blue-900/10 border-blue-200 dark:border-blue-800',
    green: 'bg-green-50 dark:bg-green-900/10 border-green-200 dark:border-green-800',
    purple: 'bg-purple-50 dark:bg-purple-900/10 border-purple-200 dark:border-purple-800',
    gray: 'bg-gray-50 dark:bg-gray-800 border-gray-200 dark:border-gray-700'
  }


</script>

<div class="privacy-preview">
  <!-- 헤더 -->
  <div class="mb-3">
    <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
      공개 범위 미리보기
    </p>
  </div>

  <!-- 미리보기 카드 -->
  <div class="rounded-xl border-2 p-4 {colorClasses[current.color as keyof typeof colorClasses]}">
    <!-- 제목 -->
    <div class="flex items-start gap-2 mb-3">
      <span class="text-2xl">{current.icon}</span>
      <div class="flex-1">
        <p class="text-sm font-bold text-gray-900 dark:text-white">
          {current.label}
        </p>
        <p class="text-xs text-gray-600 dark:text-gray-300 mt-0.5">
          {current.description}
        </p>
      </div>
    </div>

    <!-- 공개 범위 항목 -->
    <div class="space-y-1 mt-3 pt-3 border-t-2 border-opacity-20 border-gray-400 dark:border-gray-600">
      {#each current.visibility as item}
        <div class="flex items-center gap-2 text-xs">
          {#if item.includes('공개') || item.includes('가능') || item.includes('표시')}
            <span class="text-green-600 dark:text-green-400 font-bold">✓</span>
            <span class="text-gray-700 dark:text-gray-300">{item}</span>
          {:else}
            <span class="text-gray-400 dark:text-gray-500 font-bold">✗</span>
            <span class="text-gray-500 dark:text-gray-400 line-through">{item}</span>
          {/if}
        </div>
      {/each}
    </div>

    <!-- 사용자 기준 보기 -->
    <div class="mt-3 pt-3 border-t border-gray-300/30 dark:border-gray-600/30">
      <p class="text-xs font-semibold text-gray-600 dark:text-gray-400 mb-2">
        📌 다른 사용자가 보는 것:
      </p>
      <div class="bg-white/50 dark:bg-gray-900/30 rounded-lg p-2 text-xs text-gray-700 dark:text-gray-300">
        <span class="font-medium">"당신의 담벼락에서"</span><br />
        <span class="inline-block mt-1">
          {#if privacy === 'full_disclosure'}
            {currentUser?.name || '홍길동'} · 삼성전자
          {:else if privacy === 'company_only'}
            익명 · 삼성전자
          {:else if privacy === 'name_only'}
            {currentUser?.name || '홍길동'}
          {:else}
            익명
          {/if}
        </span>
      </div>
    </div>
  </div>
</div>

<style>
  .privacy-preview {
    width: 100%;
  }
</style>
